import {AbstractControl, ValidatorFn} from '@angular/forms';
import {AutocompleteStringValidatorKey} from './custom-validator-keys';

export function AutocompleteStringValidator(validOptions: Array<string>): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        if (validOptions.indexOf(control.value) !== -1) {
            return null;
        }
        
        return {[AutocompleteStringValidatorKey]: true};
    }
}